const HTMLSection = 'main-collection'
const PATHNAME = window.location.pathname

class Sidebar extends HTMLElement {
  constructor() {
    super()
    this.sidebarForm = this.querySelector('form')
    this.grid = document.getElementById('CollectionAjaxResult')
    this.sidebarForm.addEventListener('input', this.onSubmitHandler)

    const { searchParams: params } = Sidebar.getRoute()
    params.forEach((value, key) => {
      console.log(value, key)
      const isFilter = key.includes('filter.')
      const isEmpty = value === ''
      if (isFilter && !isEmpty)
        this.closest('.collection-sidebar__group').remove()
    })
  }

  onSubmitHandler = event => {
    if (this.grid) this.grid.style.opacity = '0.5'
    if (this.grid) this.grid.classList.add('loading')
    event.preventDefault()
    const checkedTagFilters = [
      ...this.sidebarForm.querySelectorAll('input:checked'),
    ]
    const tagFilterUrl = checkedTagFilters
      .map(input => input.name.trim())
      .join('+')

    const url = Sidebar.generateURL(tagFilterUrl)
    location.href = url
  }

  static getRoute() {
    const uri = new URL(location.href)
    const search = uri.search

    const parts = uri.pathname.split('/')
    const collection = parts[2]
    const tags = parts[3] || ''
    const getTags = () => (parts[3] ? parts[3].split('+') : undefined)
    return { collection, tags, search, getTags, searchParams: uri.searchParams }
  }

  static generateURL(tagFilters, navigate = true) {
    const { collection, search } = Sidebar.getRoute()

    return `/collections/${collection}/${tagFilters}${search}`

    // Cambiar URL
    if (navigate) history.pushState({}, null, url)
    return url
  }
}
Sidebar.filterData = {}

customElements.define('side-bar', Sidebar)
